import { useState } from "react";
import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Send } from "react-feather";
import PageShell from "../../components/premium/layout/PageShell";
import PageHero from "../../components/premium/layout/PageHero";

const contactCards = [
  {
    icon: Phone,
    title: "Phone",
    value: "+91 9100241284",
    href: "tel:+919100241284",
  },
  {
    icon: Mail,
    title: "Email",
    value: "hr@eptpravahaa.com",
    href: "mailto:hr@eptpravahaa.com?subject=Inquiry%20from%20Website",
  },
  {
    icon: MapPin,
    title: "Office",
    value: "EPT Towers, Madhapur, Hyderabad 500081",
    href: "https://www.google.com/maps/search/?api=1&query=EPT+TOWERS,+Madhapur,+Hyderabad",
  },
];

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = `mailto:hr@eptpravahaa.com?subject=Contact from ${encodeURIComponent(form.name)}&body=${encodeURIComponent(form.message + "\n\nFrom: " + form.email)}`;
  };

  return (
    <PageShell>
      <PageHero
        badge="Contact Us"
        title="Let's Build"
        highlight="Together"
        subtitle="Reach out for partnerships, product inquiries, or support — we're here to help."
      />

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-6 mb-12">
            {contactCards.map((c, i) => (
              <motion.a
                key={c.title}
                href={c.href}
                target={c.title === "Office" ? "_blank" : undefined}
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="premium-glass rounded-2xl p-6 block hover:border-[#F5C044]/30 transition-colors group"
              >
                <div className="w-12 h-12 rounded-xl bg-[#2563EB]/25 flex items-center justify-center text-[#60a5fa] mb-4 group-hover:scale-110 transition-transform">
                  <c.icon size={22} />
                </div>
                <p className="text-white/50 text-sm uppercase tracking-wider">{c.title}</p>
                <p className="text-white font-medium mt-2">{c.value}</p>
              </motion.a>
            ))}
          </div>

          <div className="grid lg:grid-cols-2 gap-10">
            <motion.form
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              onSubmit={handleSubmit}
              className="premium-glass premium-glass-glow rounded-3xl p-8 lg:p-10 space-y-5"
            >
              <h3 className="text-2xl font-bold text-white">Send a Message</h3>
              <div>
                <label className="block text-sm text-white/60 mb-2">Name</label>
                <input
                  className="premium-input"
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Your name"
                />
              </div>
              <div>
                <label className="block text-sm text-white/60 mb-2">Email</label>
                <input
                  type="email"
                  className="premium-input"
                  required
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="you@email.com"
                />
              </div>
              <div>
                <label className="block text-sm text-white/60 mb-2">Message</label>
                <input
                  className="premium-input"
                  required
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  placeholder="How can we help?"
                />
              </div>
              <button type="submit" className="hero-btn-primary w-full flex items-center justify-center gap-2 py-4 rounded-xl text-white font-semibold">
                <Send size={18} /> Send Message
              </button>
            </motion.form>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="premium-glass rounded-3xl overflow-hidden min-h-[320px] flex flex-col"
            >
              <div className="p-6 border-b border-white/10">
                <h3 className="text-xl font-bold text-white">Find Us</h3>
                <p className="text-white/55 text-sm mt-1">EPT Towers, Hyderabad</p>
              </div>
              <iframe
                title="EPT Pravahaa Location"
                className="flex-1 w-full min-h-[280px] border-0 grayscale opacity-80 hover:opacity-100 transition-opacity"
                src="https://maps.google.com/maps?q=EPT+TOWERS+Madhapur+Hyderabad&t=&z=14&ie=UTF8&iwloc=&output=embed"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
